const envObject = [
	{ text: '', key: 'text.outdoor', value: 1 },
	{ text: '', key: 'text.indoor', value: 0 },
];

function getEnvList(_this) {
	envObject.forEach((x) => {
		x.text = _this.$t(x.key);
	});
	return envObject;
}

export default getEnvList;
